export function getSubStepTypeIds(stepItemType: string): string[] {
  switch (stepItemType) {
    case 'answer':
      return ['answers']
    case 'carousel':
      return ['carousel']
    case 'carousel.button':
      return ['carousel', 'buttons']
    default:
      return []
  }
}
